<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :title="'发送会员'"
        :visible.sync="chioseDialog"
        center
        width="1200px"
    >
        <div class="flex align-center justify-around chiose-title">
            <span :class="{ primary: type === 1 }" @click="type = 1">标签选择</span>
            <span :class="{ primary: type === 2 }" @click="type = 2">条件筛选</span>
        </div>

        <div v-if="type === 1" class="padding-tb">
            <div class="flex align-center margin-bottom-sm">
                <span>标签选择：</span>
                <el-select
                    v-model="label"
                    class="flex-sub"
                    clearable
                    filterable
                    multiple
                    placeholder="请选择标签"
                    @change="chioseMember"
                >
                    <el-option
                        v-for="(item, index) in labels"
                        :key="index"
                        :label="item.title"
                        :value="index"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="flex align-start margin-bottom-sm">
                <span class="label-title">会员选择：</span>
                <div class="flex-sub">
                    <el-transfer
                        v-model="value"
                        :data="memberList"
                        :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }"
                        :props="{
              key: 'id',
              label: 'company_name',
            }"
                        :titles="['全部会员', '已选择会员']"
                        filterable
                        style="text-align: left; display: inline-block"
                    >
                        <span slot-scope="{ option }">{{ option.label }}</span>
                    </el-transfer>
                </div>
            </div>

            <div class="flex align-center justify-around">
                <el-button class="font-size" style="width: 200px" @click="cancelChiose"
                >关闭
                </el-button
                >
                <el-button
                    class="font-size"
                    style="width: 200px"
                    type="primary"
                    @click="labelSave"
                >确定
                </el-button
                >
            </div>
        </div>
        <div v-if="type === 2" class="padding-tb">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="search-some">
                        <span>会员等级</span>
                        <el-select
                            v-model="level"
                            class="flex-sub"
                            clearable
                            collapse-tags
                            multiple
                            placeholder="请选择会员等级"
                        >
                            <el-option
                                v-for="item in levelList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="search-some">
                        <span>单位性质</span>
                        <el-select
                            v-model="nature"
                            class="flex-sub"
                            clearable
                            collapse-tags
                            multiple
                            placeholder="请选择单位性质"
                        >
                            <el-option
                                v-for="item in natureList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="search-some">
                        <span>会员分类</span>
                        <el-select
                            v-model="memberType"
                            class="flex-sub"
                            placeholder="请选择会员分类"
                        >
                            <el-option
                                v-for="item in memberTypeList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="search-some">
                        <span>证书情况</span>
                        <el-select
                            v-model="apply"
                            class="flex-sub"
                            placeholder="请选择证书情况"
                        >
                            <el-option
                                v-for="item in applyList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col v-if="memberType === 1" :span="8">
                    <div class="search-some">
                        <span>服务类别</span>
                        <el-select
                            v-model="supply"
                            class="w-all"
                            clearable
                            collapse-tags
                            multiple
                            placeholder="请选择服务类别"
                        >
                            <el-option
                                v-for="item in supplyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col v-if="memberType === 2" :span="8">
                    <div class="search-some">
                        <span>服务类别</span>
                        <el-select
                            v-model="demand"
                            class="w-all"
                            clearable
                            collapse-tags
                            multiple
                            placeholder="请选择服务类别"
                        >
                            <el-option
                                v-for="item in demandList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="8">
                    <div class="search-some">
                        <span>注册地区</span>
                        <el-select
                            v-model="registerAddress"
                            class="flex-sub"
                            clearable
                            collapse-tags
                            multiple
                            placeholder="请选择注册地区"
                        >
                            <el-option
                                v-for="item in addressList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="search-some">
                        <span>经营地区</span>
                        <el-select
                            v-model="mailAddress"
                            class="flex-sub"
                            clearable
                            collapse-tags
                            multiple
                            placeholder="请选择经营地区"
                        >
                            <el-option
                                v-for="item in addressList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="search-some">
                        <span>缴费状态</span>
                        <el-select
                            v-model="pay"
                            class="flex-sub"
                            placeholder="请选择缴费状态"
                        >
                            <el-option
                                v-for="item in payList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="8" class="search-some">
                    <span>到期时间：</span>
                    <el-date-picker
                        v-model="endTime"
                        class="flex-sub"
                        end-placeholder="结束日期"
                        range-separator="至"
                        start-placeholder="开始日期"
                        type="daterange"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :span="8" class="search-some">
                    <div class="flex align-center justify-end padding-bottom-sm">
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="search"
                        >搜索
                        </el-button
                        >
                        <el-button
                            class="margin-left font-size"
                            type="primary"
                            @click="reset"
                        >重置
                        </el-button
                        >
                    </div>
                </el-col>
            </el-row>

            <h3 v-if="conditionList.length > 0" class="padding-bottom-sm">
                筛选结果：{{ conditionList.length }}家
            </h3>
            <div v-if="conditionList.length > 0" class="condition-list padding-sm">
                <el-row :gutter="20">
                    <el-col class="flex align-center justify-between" v-for="(item,index) in conditionList" :key="item.id" :span="8">
                        <p class="ovHide">{{ item.company_name }}</p><el-button type="text" @click="delItem(index)">删除</el-button>
                    </el-col>
                </el-row>
            </div>

            <div class="flex align-center justify-around">
                <el-button class="font-size" style="width: 200px" @click="cancelChiose"
                >关闭
                </el-button
                >
                <el-button
                    class="font-size"
                    style="width: 200px"
                    type="primary"
                    @click="conditionSave"
                >确定
                </el-button
                >
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {
    address,
    applyList,
    demand,
    level,
    memberType,
    nature,
    optionList,
    payList,
    supply,
    zhDate
} from "@/utils/utils";
import {conditionSelect, customLabelView, labelSelect} from '@/api/admin'

export default {
    name: "chioseDialog",
    props: {
        chioseDialog: {
            type: Boolean,
            default: false
        },
        chioseType: {
            type: Number
        },
    },
    data() {
        return {
            type: 1,
            labels: [],
            label: [],
            value: [],
            memberList: [],
            renderFunc(h, option) {
                return <span>{option.key} - {option.label}</span>;
            },

            levelList: optionList(false, level),
            level: [],
            natureList: optionList(false, nature),
            nature: [],
            memberTypeList: memberType,
            memberType: 0,
            applyList: applyList,
            apply: 0,
            supplyList: optionList(false, supply),
            supply: [],
            demandList: optionList(false, demand),
            demand: [],
            addressList: optionList(false, address),
            registerAddress: [],
            mailAddress: [],
            payList: payList,
            pay: 0,
            endTime: null,
            conditionList: [],
        }
    },
    created() {
        this.init()
    },
    methods: {
        //  关闭选择框
        cancelChiose() {
            this.$emit('cancelChiose')
        },

        //  重置
        reset() {
            this.level = []
            this.nature = []
            this.memberType = 0
            this.apply = 0
            this.supply = []
            this.demand = []
            this.registerAddress = []
            this.mailAddress = []
            this.pay = 0
            this.endTime = null
            this.conditionList = []
        },
        //  搜索
        async search() {
            let _data = await conditionSelect(2,
                this.level.join(','),
                this.nature.join(','),
                this.apply,
                this.memberType,
                this.memberType === 0 ? '' : this.memberType === 1 ? this.supply.join(',') : this.demand.join(','),
                this.registerAddress.join(','),
                this.mailAddress.join(','),
                this.pay,
                this.endTime && this.endTime.length > 0 ? zhDate(new Date(this.endTime[0])) : '',
                this.endTime && this.endTime.length > 0 ? zhDate(new Date(this.endTime[1])) : ''
            )
            this.conditionList = _data.data
            if (_data.data.length === 0) return this.$message.error('暂无数据')
        },
        delItem(index) {
            this.$confirm("确定要删除该会员吗", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.conditionList.splice(index,1)
            })
        },
        //  筛选条件保存
        conditionSave() {
            if (this.conditionList.length === 0) return this.$message.error('请筛选要发送的会员')
            this.value = []
            this.conditionList.map(item => {
                this.value.push(item.id)
            })
            this.$emit('saveChiose', [2, this.value])
        },
        //  选择标签保存
        labelSave() {
            if (this.value.length === 0) return this.$message.error('请选择要发送的会员')
            this.$emit('saveChiose', [1, this.value])
        },

        //  选择标签 会员数据同步
        chioseMember(val) {
            let _arr = []
            val.map(item => {
                if (this.labels[item].user_ids) {
                    _arr = [..._arr, ...this.labels[item].user_ids.split(',').map(Number)]
                    _arr = [...new Set(_arr)]
                }
            })
            this.value = _arr
        },
        //  获取全部标签和会员
        async init() {
            let _data = await labelSelect(1)
            this.labels = _data.data

            let _allMember = await customLabelView()
            _allMember.data.map(item => {
                item.label = item.company_name
                item.key = item.id
            })
            this.memberList = _allMember.data
        }

    },
    watch: {
        chioseType() {
            this.type = this.chioseType
        }
    }
}
</script>

<style lang="scss" scoped>
.chiose-title {
    width: 500px;
    margin: 0 auto;

    span {
        display: block;
        width: 180px;
        height: 40px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;

        &.primary {
            background: #0d7fd7;
            color: #fff;
        }
    }
}

.search-some {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    span {
        display: block;
        width: 80px;
    }

    .el-input {
        flex: 1;
    }

    .el-select {
        flex: 1;
    }
}

.condition-list {
    height: 200px;
    overflow-y: auto;
    border: 1px solid #ccc;
    margin-bottom: 30px;
}
</style>